import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { inputCls, btnPrimary } from "@/lib/labels";

export const ReasonDialog = ({ open, title, label, required = true, confirmText, onClose, onConfirm, testId }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await onConfirm(reason.trim());
      setReason("");
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent dir="rtl" className="border-purple-500/30 bg-[var(--km-bg2)] text-white" data-testid={testId}>
        <DialogHeader className="text-right sm:text-right"><DialogTitle className="font-display text-2xl">{title}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <label className="block">
            <span className="mb-1 block text-sm font-bold">{label}</span>
            <textarea className={`${inputCls} min-h-[90px]`} value={reason} onChange={(e) => setReason(e.target.value)} required={required} minLength={required ? 3 : 0} maxLength={300} data-testid={`${testId}-input`} />
          </label>
          <button type="submit" disabled={busy} className={btnPrimary} data-testid={`${testId}-confirm`}>{busy && <Loader2 className="h-4 w-4 animate-spin" />} {confirmText}</button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
